import React, { Component } from 'react';
import FormInputContainer from "./FormInputContainer";
import {Validate, Send} from "../../actions/FormHandler.js";

export default class AppointmentForm extends Component{
    constructor(props) {
        super(props);
        this.state = {
            disabled: false
        };
    }
    render() {
        return (
            <form id="appointment-form" method="POST" onSubmit={ (e) => {
                this.props.modal.Send(e, this.props.gender, this.props.cabinetId, this.props.serviceId, this.props.offset, this);
            } }>
                <div className="appointment__modal__form_container">
                    <h1 style={{fontSize: '36px', marginBottom: '10px'}}>Запись на прием</h1>
                    <div className="row">
                        <div className="column">
                            <FormInputContainer
                                label={'Дата'}
                                value={this.props.date}
                                readOnly={true}
                                name={'AppointmentForm[date]'}
                                icon={'fa fa-calendar-check-o'}
                                input_id="date"
                            />
                            <FormInputContainer
                                label={'Фамилия'}
                                placeholder={'Введите фамилию'}
                                name={'AppointmentForm[last_name]'}
                                icon={'fa fa-user'}
                                input_id="last_name"
                            />
                            <FormInputContainer
                                label={'Имя'}
                                placeholder={'Введите имя'}
                                name={'AppointmentForm[first_name]'}
                                icon={'fa fa-user'}
                                input_id="first_name"
                            />
                            <FormInputContainer
                                label={'Отчество'}
                                placeholder={'Введите отчество'}
                                name={'AppointmentForm[middle_name]'}
                                icon={'fa fa-user'}
                                input_id="middle_name"
                            />
                            <FormInputContainer
                                label={'Дата рождения'}
                                placeholder={'Введите дату рождения'}
                                name={'AppointmentForm[birthdate]'}
                                icon={'fa fa-birthday-cake'}
                                input_id="birthdate"
                                mask={'99.99.9999'}
                            />
                        
                        </div>
                        <div className="column">
                            <FormInputContainer
                                label={'Время'}
                                value={this.props.time}
                                readOnly={true}
                                name={'AppointmentForm[time]'}
                                input_id="time"
                                icon={'fa fa-clock-o'}
                            />
                            <FormInputContainer
                                label={'Телефон'}
                                placeholder={'Введите телефон'}
                                name={'AppointmentForm[phone]'}
                                icon={'fa fa-mobile'}
                                input_id="phone"
                                mask={'+7 (999) 999 99 99'}
                            />
                            <FormInputContainer
                                label={'Email'}
                                placeholder={'Введите email'}
                                name={'AppointmentForm[email]'}
                                icon={'fa fa-envelope-o'}
                                input_id="email"
                            />
                            <FormInputContainer
                                label={'Место работы'}
                                placeholder={'Введите место работы'}
                                name={'AppointmentForm[workplace]'}
                                icon={'fa fa-briefcase'}
                                input_id="workplace"
                            />
                        </div>
                    </div>
                    <button className="appointment_form_button" type="submit" disabled={this.state.disabled}>Записаться</button>
                    <span>Нажимая эту кнопку, вы даете согласие на обработку своих <a href="/personal" className="link">персональных данных</a></span>
                </div>
            </form>
        );
    }

};



// WEBPACK FOOTER //
// frontend/src/modules/AppointmentForm/AppointmentForm.js